(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/reducer.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/reducer.js');

const initialState = {
  companyDetails: {
    companyName: '',
    organizationNumber: '',
    addresses: [],
    eMail: '',
    contactPerson: '',
    phone: '',
    cellPhone: '',
    legalCompanyName: '',
    userTermsApproved: false,
    edit: false
  },
  password: {
    edit: false
  }
};

svs.ticket_partner.companyDetails.initialState = initialState;
svs.ticket_partner.companyDetails.initializer = (initialValue = initialState) => initialValue;
const { RECEIVE_COMPANY_DETAILS, UPDATE_ADDRESS, EDIT_MODE, UPDATE_CONTACT_PERSON, EDIT_MODE_PASSWORD } = svs.ticket_partner.companyDetails.constants.actions;
svs.ticket_partner.companyDetails.reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case RECEIVE_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: {
          ...state.companyDetails,
          ...payload
        }
      };
    case UPDATE_ADDRESS:
      const { field, value, addressToUpdate } = payload;
      return {
        ...state,
        companyDetails: {
          ...state.companyDetails, addresses: state.companyDetails.addresses.map((address) => {
            const { addressType } = address;
            if (addressToUpdate === addressType) {
              const newAdress = { ...address };
              newAdress[field] = value;
              return newAdress;
            }
            return address;
          })
        }
      };
    case EDIT_MODE:
      const { edit, beforeEditState = null } = payload;
      let companyDetailsState = { ...state.companyDetails, edit };
      if (!edit && beforeEditState) {
        companyDetailsState = { ...beforeEditState, edit };
      }
      return {
        ...state,
        companyDetails: companyDetailsState
      };
    case EDIT_MODE_PASSWORD:
      const { edit: passwordEdit } = payload;
      return {
        ...state,
        password: { ...state.password, edit: passwordEdit }
      };
    case UPDATE_CONTACT_PERSON:
      return {
        ...state, companyDetails: {
          ...state.companyDetails, [payload.field]: payload.value
        }
      };
    default:
      return state;
  }
};


 })(window);